import React, { useEffect, useState } from 'react';
import './settings.scss';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import data from 'bootstrap/js/src/dom/data';
import { useIntl } from 'react-intl';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import { getSettingsData } from '../reducer';
import { checkBoxFormatter, regNumberFormatter } from '../../../utils/formatters';
import FileInput from '../../../components/fields/FileInput/FileInput';
import Grid from '../../../components/base/Grid/Grid';
import { showGlobalConfirm } from '../../System/actions';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import Loader from '../../../components/base/Loader/Loader';
import {
  addToWhiteList, deleteFromWhiteList, importWhiteList, loadWhiteList,
} from '../actions';
import { getResponseError, responseLogWithNotification, useUpdatePeriod } from '../../../utils/utils';
import notificationDecorator, {
  errorNotification,
  successNotification,
} from '../../Notifications/notificationDecorator';
import { getSystemData } from '../../System/reducer';
import UploadZone from '../../../components/fields/FileInput/UploadZone';

export default function ExceptionColumn() {
  const [selected, setSelected] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [newLPN, setNewLPN] = useState('');
  const [newBase, setNewBase] = useState('');
  const [filter, setFilter] = useState('');
  const dispatch = useDispatch();
  const intl = useIntl();
  const { formatMessage } = intl;
  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingWhiteList, whiteList, loadingAddToWhite, loadingDeleteFromWhiteList, loadingImportWhiteList,
  } = useSelector(getSettingsData);
  const loadData = () => {
    const p1 = dispatch(loadWhiteList()).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const setFileClear = f => { window.clearFileFunction = f; };

  const cancel = () => {
    if (window.clearFileFunction) {
      window.clearFileFunction();
    }
  };

  const handleImportFile = data => {
    dispatch(importWhiteList(data)).then(() => {
      loadData();
      setShowUpload(false);
      successNotification(formatMessage({ id: 'exception.load' }), formatMessage({ id: 'exception.load.success' }));
      cancel();
    }).catch(response => {
      if (response && response.errors && response.errors.length) {
        return errorNotification(formatMessage({ id: 'exception.load' }), response.errors.map(i => i.message).slice(0, 3).join('\n '));
      }
      errorNotification(formatMessage({ id: 'exception.load' }), getResponseError(response));
      cancel();
    });
  };

  const handleDelete = event => {
    dispatch(showGlobalConfirm({
      confirmMessage: formatMessage({ id: 'exception.delete' }),
      confirmButtonText: formatMessage({ id: 'app.delete' }),
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteFromWhiteList(selected)).then(() => {
        loadData();
        successNotification(formatMessage({ id: 'exception.delete.title' }), formatMessage({ id: 'exception.delete.success' }));
      }).catch(response => {
        errorNotification(formatMessage({ id: 'exception.delete.title' }), getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleAdd = event => {
    dispatch(addToWhiteList({ lp_text: newLPN, reason: newBase })).then(() => {
      loadData().then(() => {
        setShowCreate(false);
        setNewLPN('');
        setNewBase('');
      });
      successNotification(formatMessage({ id: 'exception.add' }), formatMessage({ id: 'exception.add.success' }));
    }).catch(response => {
      errorNotification(formatMessage({ id: 'exception.add' }), getResponseError(response));
    });
  };

  const headerCheckBoxFormatter = (id, item) => {
    const isAll = whiteList.every(p => selected.includes(p.id));
    const isSome = whiteList.some(p => selected.includes(p.id)) && !isAll;
    const onChange = () => {
      if (isAll) {
        setSelected([]);
      } else {
        setSelected(whiteList.map(p => p.id));
      }
    };
    return checkBoxFormatter(isAll, onChange, classNames({ 'some-child': isSome }, { 'every-child': isAll }));
  };

  const rowCheckBoxFormatter = (_, item) => {
    const onChange = () => {
      const index = selected.indexOf(item.id);
      if (index >= 0) {
        const newSelected = [...selected];
        newSelected.splice(index, 1);
        setSelected(newSelected);
      } else {
        setSelected([...selected, item.id]);
      }
    };
    return checkBoxFormatter(selected.includes(item.id), onChange);
  };

  const columns = [
    {
      dataField: 'checkbox',
      text: formatMessage({ id: 'select.row' }),
      disableSort: true,
      headerFormatter: headerCheckBoxFormatter,
      formatter: rowCheckBoxFormatter,
      dataClassName: 'checkbox-column',
      headerClassName: 'checkbox-column',
    },
    {
      dataField: 'lp_text',
      text: formatMessage({ id: 'reg_number.short' }),
      formatter: regNumberFormatter,
      headerClassName: 'reg-number-column',
      disableSort: true,
    },
    {
      dataField: 'reason',
      text: formatMessage({ id: 'exception.base' }),
      headerClassName: 'reg-number-column',
      disableSort: true,
    },
  ];
  const filteredWhiteList = (whiteList || []).filter(item => String(item.reason).toLowerCase().includes(String(filter).toLowerCase()));
  const renderContent = () => (
    <div className="wanted-data">
      <Grid columns={columns} data={filteredWhiteList} />
    </div>
  );

  const renderCreateDialog = () => (
    <Dialog
      className={classNames('calibration-dialog-container')}
      onClose={() => { setShowCreate(false); }}
      open
    >
      <DialogTitle header={formatMessage({ id: 'exception.add' })} title={<Icons onClick={() => { setShowCreate(false); }} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content">
        <TextInputWithLabel
          label={formatMessage({ id: 'reg_number' })}
          variant="material"
          placeholder={formatMessage({ id: 'reg_number.placeholder.long' })}
          inputProps={{
            value: newLPN,
            onChange: e => setNewLPN(e.target.value),
          }}
        />
        <TextInputWithLabel
          className="mt-3"
          label={formatMessage({ id: 'exception.base' })}
          variant="material"
          placeholder={formatMessage({ id: 'exception.base.placeholder' })}
          inputProps={{
            value: newBase,
            onChange: e => setNewBase(e.target.value),
          }}
        />
      </DialogContent>
      <DialogFooter>
        <Button onClick={handleAdd}>{formatMessage({ id: 'app.save' })}</Button>
        <Button variant="secondary" onClick={() => { setShowCreate(false); }}>{formatMessage({ id: 'app.close' })}</Button>
      </DialogFooter>
    </Dialog>
  );

  const renderUpload = () => (
    <UploadZone inputProps={{ onChange: handleImportFile }} setClear={setFileClear} zoneText={formatMessage({ id: 'exception.import' })} />
  );

  const uniqueReason = whiteList.reduce((acc, current) => {
    if (!acc.filter(item => item.reason === current.reason).length) {
      acc.push(current);
    }
    return acc;
  }, []);

  return (
    <div className="settings-options frame wanted-column">
      <Loader loading={loadingWhiteList || loadingAddToWhite || loadingDeleteFromWhiteList || loadingImportWhiteList} global />
      <div className="settings-edit">
        <div className="settings-header">
          <div className="settings-label">{formatMessage({ id: 'exception' })}</div>
          <div className="settings-buttons wanted-buttons">
            {whiteList.length ? (
              <>
                <CustomSelectInput
                  addPlaceholder
                  variant="material"
                  options={uniqueReason.map(i => ({ value: i.reason, name: i.reason }))}
                  placeholder={formatMessage({ id: 'exception.base' })}
                  inputProps={{
                    value: filter,
                    onChange: e => setFilter(e.target.value),
                  }}
                />
                <div className="control-delimiter" />
                <div
                  className="settings-icon-btn"
                  onClick={() => {
                    setShowUpload(!showUpload);
                  }}
                >
                  <Icons customIcon icon="file-export" className="icon" />
                </div>
                <div className="control-delimiter" />
              </>
            ) : null}
            <div
              className="settings-icon-btn"
              onClick={() => {
                setShowCreate(true);
              }}
            >
              <Icons width={26} height={26} customIcon icon="plus" className="icon" />
            </div>

            {whiteList.length ? (
              <>
                <div className="control-delimiter" />
                <div
                  className={classNames('settings-icon-btn blue', { disabled: !selected.length })}
                  onClick={handleDelete}
                >
                  <Icons width={20} height={20} customIcon icon="trash" className="icon" />
                </div>
              </>
            ) : null}
          </div>
        </div>
        <div className="settings-form">
          <div className="settings-view-form">
            {!whiteList.length || showUpload ? renderUpload() : renderContent()}
            {showCreate ? renderCreateDialog() : null}
          </div>
        </div>
      </div>
    </div>
  );
}
